import React, { Component } from "react";
import { withRouter } from "react-router";
import PaymentForm from "../../Components/PaymentForm";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";

class Pay extends Component {
	constructor(props){
		super(props);
		this.state = {
			loaded: false,
			isWhiteLabel: ((state) => state?.branding.partnerPreferencesOn)
		};
	}

	UNSAFE_componentWillMount(){
		const that = this;
		let sqPaymentScript = document.createElement("script");
		sqPaymentScript.src = process.env.REACT_APP_SQ_URL;
		sqPaymentScript.type = "text/javascript";
		sqPaymentScript.async = false;
		sqPaymentScript.onload = ()=>{that.setState({
			loaded: true
		});};
		let nextDoorPixelScript = document.createElement("script");
		let content = document.createTextNode("ndp('track','CONVERSION');");
		nextDoorPixelScript.append(content);
		document.getElementsByTagName("head")[0].append(sqPaymentScript, nextDoorPixelScript); 
	}

	render() {
		return (
			this.state.loaded &&
				<>
					<PaymentForm
						price={this.props.match.params.price}
						paymentForm={ window.SqPaymentForm }
						paymentSource={this.state.isWhiteLabel ? "whitelabel" : "webapp"}
					/>
					<noscript>
						<img height="1" width="1" style="display:none" src="https://flask.nextdoor.com/pixel?pid=cd8abc59-39d9-44dd-9e64-c07769ccf70a&ev=CONVERSION&noscript=1"/>
					</noscript>
				</>
		);
	}
}

export default withRouter(Pay);
